var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRtrim = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M21 6a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M15.575 13.375a.32.32 0 0 0 .468-.283.2.2 0 0 0-.03-.108.24.24 0 0 0-.1-.087l-1.088-.561a1 1 0 0 0-.145-.06c-.04-.015-.04-.08 0-.093q.075-.027.145-.063l1.089-.558a.25.25 0 0 0 .098-.084.2.2 0 0 0 .03-.111.32.32 0 0 0-.468-.284l-1.774.926a.248.248 0 0 0 0 .438zm-7.221.875h.624q.105 0 .174-.051a.3.3 0 0 0 .096-.132l.324-.885h1.796l.325.885a.3.3 0 0 0 .096.126.26.26 0 0 0 .17.057h.627l-1.704-4.338h-.825zm2.808-1.638H9.779l.527-1.443a7 7 0 0 0 .082-.225q.041-.132.084-.285a7 7 0 0 0 .162.516l.527 1.437Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRtrim);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rtrim.f62df764.svg";